// extracted by mini-css-extract-plugin
export var circle = "_gc-1";
export var exitConfirmationModal = "_gc-5";
export var iframe = "_gc-0";
export var offline = "_gc-3";
export var online = "_gc-2";
export var workstationSelectError = "_gc-4";